import React from 'react';
import './WelcomePage.css'
const WelcomePage = () => {
    return (
        <div className="card-img">
            <img src="https://thefinancialexpress.com.bd/uploads/1578838247.jpeg" alt="" className="w-100 " />
            <h2 className="butn fw-bold ">Welcome To Dashboard</h2>
        </div>
    );
};

export default WelcomePage;